<template>
  <swiper :options="swiperOption" :ref="refNode" v-if="swiperImgs.length">
    <!-- slides -->
    <swiper-slide
      class="slide-img-box"
      v-for="(item, index) in swiperImgs"
      :key="item.ID"
    >
      <a :href="item.link" target="_blank" v-if="isLink">
        <img
          class="swiper-slide-img"
          :src="item.topimage"
          :style="{ height: height }"
          @click.stop="onSlide(index)"
        />
      </a>
      <img
        v-else
        class="swiper-slide-img"
        :src="item.topimage"
        :style="{ height: height }"
        @click.stop="onSlide(index)"
      />
    </swiper-slide>
    <div v-if="isPagination" class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "MySwiper",
  components: {
    swiper,
    swiperSlide
  },
  props: {
    isLink: {
      type: Boolean,
      default: true
    },
    refNode: {
      type: String,
      default: "mySwiper"
    },
    isPagination: {
      type: Boolean,
      default: true
    },
    isPage: {
      type: Boolean,
      default: true
    },
    isText: {
      type: Boolean,
      default: false
    },
    isBackground: {
      type: Boolean,
      default: false
    },
    isNavigation: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default() {
        return {
          pagination: {
            el: ".swiper-pagination"
          }
        };
      }
    },
    height: {
      type: String,
      default: "auto"
    },
    slidesPer: {
      type: Number,
      default: 1
    },
    swiperImgs: {
      type: Array,
      required: true,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      // swiper 配置
      swiperOption: Object.assign(
        {},
        {
          // autoplay: true, // swiper 自动播放

          autoplay: {
            delay: 5000
          }, // swiper 自动播放
          autoHeight: true, // swiper 的高度跟随 slide 的高度变化
          slidesPerView: this.slidesPer,
          spaceBetween: 20
        },
        this.options
      )
    };
  },
  computed: {
    swiper() {
      return this.$refs[this.refNode].swiper;
    }
  },
  watch: {},
  beforeMount: function() {},
  methods: {
    onSlide(v) {
      this.$emit("on-slide", v);
    },
    onOpen(v) {
      window.open(v.LinkToUrl, "_blank");
    },
    onSwiper(v) {
      this.$emit("on-swiper", v);
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.slide-img-box {
  text-align: center;
}

.swiper-slide-img {
  max-width: 100%;
}

.swiper-pagination-bullet-active {
  background: var(--color-green);
}
</style>
